import httpClient from './httpClient';

const PostRefnoInform = req => httpClient.post('/PostRefnoInform', req);
const PostUpdateAuthConfirm = req => httpClient.post('/paotang/PostUpdateAuthConfirm', req);
const PostPaotangAuthInit = (cifno) => httpClient.post('/paotang/auth/init', { cifno });
const PostPaotangExchange = (code, state) => httpClient.post('/paotang/auth/exchange', { code, state });

export default {
    PostRefnoInform,
    PostUpdateAuthConfirm,
    PostPaotangAuthInit,
    PostPaotangExchange,
};